import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  fetchIntegration: `${NAMESPACE}_LOCALZ_INTEGRATION_FETCH`,

  setConnectionState: `${NAMESPACE}_LOCALZ_INTEGRATION_SET_IS_CONNECTING`,
  setIsLoadingIntegration: `${NAMESPACE}_LOCALZ_INTEGRATION_IS_LOADING`,
  updateIntegration: `${NAMESPACE}_LOCALZ_INTEGRATION_UPDATE`,
  connectIntegration: `${NAMESPACE}_LOCALZ_INTEGRATION_CONNECT`,

  disableIntegration: `${NAMESPACE}_LOCALZ_INTEGRATION_DISABLE`,
  setDisableState: `${NAMESPACE}_LOCALZ_INTEGRATION_SET_DISABLE_STATE`,
  clearIntegrationDisableState: `${NAMESPACE}_LOCALZ_INTEGRATION_DISABLE_CLEAR_STATUS`,
  clearIntegrationConnectState: `${NAMESPACE}_LOCALZ_INTEGRATION_CONNECT_CLEAR_STATUS`,
};

export const actionCreators = {
  setIsLoadingIntegration: ({ isLoading }) => ({ type: actions.setIsLoadingIntegration, payload: { isLoading } }),

  setConnectionState: (payload) => ({ type: actions.setConnectionState, payload }),
  connectIntegration: (payload) => ({ type: actions.connectIntegration, payload }),

  fetchIntegration: (payload) => ({ type: actions.fetchIntegration, payload }),

  updateIntegration: (payload) => ({ type: actions.updateIntegration, payload }),

  disableIntegration: (payload) => ({ type: actions.disableIntegration, payload }),
  setDisableState: () => ({ type: actions.setDisableState }),
  clearIntegrationDisableState: () => ({ type: actions.clearIntegrationDisableState }),
  clearIntegrationConnectState: () => ({ type: actions.clearIntegrationConnectState }),
}

export default {
  actions,
  actionCreators
};
